/**
 * ./src/modules/product/services/sampleDepartments.tsx
 *
 * Definitions and configurations for Sample departments
 *
 * @copyright DesignShop, 2024
 * @since 06/17/2024
 */

export const departmentAssets = {
  pearl:
    'https://images.ctfassets.net/zkiqcy76d1dl/6TLuyQqyzcPIy7uikAehj2/a45cf6e812f05c434b4820bafb6b79f1/pearl.png',
  paint:
    'https://images.ctfassets.net/zkiqcy76d1dl/1DDLjTe54yjKIVv3to9rWT/0a342ee4f2e18a7e321832d8fcd9b06c/paint.png',
  wood: 'https://images.ctfassets.net/zkiqcy76d1dl/bTPLaHBJe6dK35y7Cddsd/6bf15fd45c75a1bd165dca3eeaf43768/wood.png',
  products:
    'https://images.ctfassets.net/zkiqcy76d1dl/589RJm8Ut31KExAt8boIZA/bc1d128a7b8436263622882e7ff3f8b7/products.png',
  paper:
    'https://images.ctfassets.net/zkiqcy76d1dl/2FE0VinQC2uut5lmBo5Y2N/c590257ed801bc006438532f9d7c7072/paper.png',
  stone:
    'https://images.ctfassets.net/zkiqcy76d1dl/5g7xHyzVEYTW7BrXJBlh93/96503828dc629d1a2ea51c243acbc805/stone.png',
  felt: 'https://images.ctfassets.net/zkiqcy76d1dl/69vxEptcc5DyYkf1AbrNey/60af7241bd7948c47803f9e834e119e8/felt.png',
  textile:
    'https://images.ctfassets.net/zkiqcy76d1dl/68PmUvqriKXhTCeIwXfC0/faeaaef3081c9ddb4a231077c64fcee4/textile.png',
  film: 'https://images.ctfassets.net/zkiqcy76d1dl/687SWaUE621M5JEwXcHL0t/3e4dc7a95ad15c33c4998cb4433568eb/film.png',
  carpet:
    'https://images.ctfassets.net/zkiqcy76d1dl/1FnLmEBbEgI5CdgwE0YPLV/89d2609baa7a109a10aa29a93a68c991/carpet.png',
  flooring:
    'https://images.ctfassets.net/zkiqcy76d1dl/x7BlV4EkODcNE4hrXjtDw/31b348d910833f9484cc569d5c068e41/flooring.png',
  concrete:
    'https://images.ctfassets.net/zkiqcy76d1dl/16E8WysC8y6mO5uJEqkmri/556c8d56034331845a41210acacc103b/concrete.png',
  linoleum:
    'https://images.ctfassets.net/zkiqcy76d1dl/1wOKniYo9muwzkFFAruRMV/30b7b80707ca29b1d59e467d7f3bf2bf/linoleum.png',
};

/**
 * Sample departments
 */
export const sampleDepartments = [
  {
    title: 'Tile',
    slug: 'tile',
    thumbnailUrl: departmentAssets.pearl,
  },
  {
    title: 'Paint',
    slug: 'paint',
    thumbnailUrl: departmentAssets.paint,
  },
  {
    title: 'Wallpaper',
    slug: 'wallpaper',
    thumbnailUrl: departmentAssets.paper,
  },
  // {
  //   title: 'Tile Flooring',
  //   slug: 'tile-flooring',
  //   thumbnailUrl: departmentAssets.pearl,
  // },
  {
    title: 'Wood Flooring',
    slug: 'wood-flooring',
    thumbnailUrl: departmentAssets.flooring,
  },
  {
    title: 'Vinyl, Laminate, & Specialty Flooring',
    slug: 'vinyl-laminate-specialty-flooring',
    thumbnailUrl: departmentAssets.flooring,
  },
  {
    title: 'Countertops',
    slug: 'countertops',
    thumbnailUrl: departmentAssets.concrete,
  },
  {
    title: 'Blinds & Shades',
    slug: 'blinds-and-shades',
    thumbnailUrl: departmentAssets.film,
  },
  {
    title: 'Decking',
    slug: 'decking',
    thumbnailUrl: departmentAssets.concrete,
  },
  {
    title: 'Fabric',
    slug: 'fabric',
    thumbnailUrl: departmentAssets.textile,
  },
  // {
  //   title: 'Acoustic Wallcovering',
  //   slug: 'acoustic-wallcovering',
  //   thumbnailUrl: departmentAssets.linoleum,
  // },
  {
    title: 'Carpet & Carpet Tile',
    slug: 'carpet-and-carpet-tile',
    thumbnailUrl: departmentAssets.felt,
  },
  {
    title: 'Area Rugs',
    slug: 'area-rugs',
    thumbnailUrl: departmentAssets.carpet,
  },
  {
    title: 'Paneling',
    slug: 'paneling',
    thumbnailUrl: departmentAssets.wood,
  },
  {
    title: 'Hardware',
    slug: 'hardware',
    thumbnailUrl: departmentAssets.products,
  },
  {
    title: 'Fixtures',
    slug: 'fixtures',
    thumbnailUrl: departmentAssets.products,
  },
  {
    title: 'Cabinets',
    slug: 'cabinets',
    thumbnailUrl: departmentAssets.stone,
  },
];

export const sampleInspiration = [
  {
    cta: 'Bathroom',
    url: '/ideas?room=Bathroom',
    thumbnail: '/img/inspiration/inspiration-bathroom.webp',
  },
  {
    cta: 'Kitchen',
    url: '/ideas?room=Kitchen',
    thumbnail: '/img/inspiration/inspiration-kitchen.webp',
  },
  {
    cta: 'Living Room',
    url: '/ideas?room=Living Room',
    thumbnail: '/img/inspiration/inspiration-living-room.png',
  },
  {
    cta: 'Bedroom',
    url: '/ideas?room=Bedroom',
    thumbnail: '/img/inspiration/inspiration-bedroom.webp',
  },
];

export const shopBy = {
  tile: {
    application: [
      'Floor Tile',
      'Wall & Backsplash Tile',
      'Pool Tiles',
      'Outdoor & Pavers',
      'Fireplace',
    ],
    material: [
      'Ceramic & Porcelain',
      'Marble & Stone',
      'Terrazzo',
      'Pebble',
      'Crackled',
      'Glass & Mirror',
      'Pearl',
      'Mosaic',
    ],
    styles: ['Concrete Look', 'Marble Look', 'Stone Look', 'Wood Look', 'Metallic Effect'],
  },
  paint: ['Exterior Paint', 'Interior Paint', 'Cabinet Paint'],
  wallpaper: ['Primer', 'Wood Stain', 'Wall Paper'],
  fabric: ['Acoustic', 'Grasscloths', 'Prints'],
  wallcovering: ['Solids & Textures', 'Wood/Composite Panel'],
};
